export default (dataCollection: any[], uniqueId = 'id') =>
  dataCollection.reduce(
    (allData: any, currentData: any) => ({
      ...allData,
      [currentData[uniqueId]]: currentData,
    }),
    {}
  )
